import React, { FC, useEffect, useReducer, useState } from 'react';

import { Popup } from './Popup';

// TYPES
import { EMessagesTypes, IState } from './PopupMessage.types';

// REDUX
import { getFreeSpins, getGeneralAppState, getPopupMessges, setPopupMessage } from '@Managers/Redux/AppState/AppState';
import { useAppDispatch, useAppSelector } from '@Managers/Redux/Hooks';

// STYLS

// MESSAGES TYPES
import { getHttpError } from '@Managers/Redux/HttpState';
import { MessageError } from './types/error/Message.error';
import { MessageFreeSpins } from './types/freeSpins/Message.free.spins';
import { MessageInsufficientFunds } from './types/insufficientFunds/Message.insufficientFunds';
import { MessageLogoutConfirmation } from './types/logoutConfirmation/Message.logoutConfirmation';

//EVENTS

const PopupMessage: FC<{}> = () => {
    const [state, setState] = useReducer((state: IState, newState: any) => ({ ...state, ...newState }), { messageType: undefined, freeSpinsAmount: 0 });
    const [isPopupOpen, setIsPopupOpen] = useState<boolean>(false);

    const messages = useAppSelector(getPopupMessges);
    const dispatch = useAppDispatch();
    const gameStoreGeneralAppState = useAppSelector(getGeneralAppState);
    const gameStoreFreeSpins = useAppSelector(getFreeSpins);
    const httpError = useAppSelector(getHttpError);

    const openPopup = (): void => {
        setIsPopupOpen(true);
    };

    const closePopup = (): void => {
        setIsPopupOpen(false);
        setState({ freeSpinsRead: true, messageType: undefined });
        dispatch(setPopupMessage({ type: undefined }));
    };

    // TAKE ACTIONS FOR ERROR MESSAGES
    useEffect(() => {
        if (gameStoreGeneralAppState.error || (httpError && httpError.requestError)) {
            setState({ messageType: EMessagesTypes.error });
            openPopup();
        }
    }, [gameStoreGeneralAppState.error, httpError]);

    // TAKE ACTIONS FOR UNIFICIENT FUNDS
    useEffect(() => {
        if (messages?.type) {
            setState({ messageType: messages?.type });
            openPopup();
        }
    }, [messages]);

    // TAKE ACTIONS FOR FREE SPINS

    useEffect(() => {
        if (gameStoreFreeSpins) {
            let open = false;

            if (gameStoreFreeSpins && !state.freeSpinsRead) open = true;
            if (gameStoreFreeSpins.balance > state.freeSpinsAmount && state.freeSpinsRead) open = true;

            if (open)
                if (open) {
                    setState({ messageType: EMessagesTypes.freeSpins, freeSpinsAmount: gameStoreFreeSpins.balance });
                    openPopup();
                }
        } else {
            setState({ freeSpinsAmount: 0 });
        }
    }, [gameStoreFreeSpins]);

    return (
        <>
            {isPopupOpen && (
                <Popup onClose={closePopup} isPopupOpen={isPopupOpen} msgType={state.messageType}>
                    {state.messageType === EMessagesTypes.error && <MessageError onClose={closePopup} />}
                    {state.messageType === EMessagesTypes.insufficientFunds && <MessageInsufficientFunds onClose={closePopup} />}
                    {state.messageType === EMessagesTypes.logoutConfirmation && <MessageLogoutConfirmation onClose={closePopup} />}
                    {state.messageType === EMessagesTypes.freeSpins && <MessageFreeSpins onClose={closePopup} />}
                </Popup>
            )}
        </>
    );
};

export default PopupMessage;
